












import Vue from 'vue'
import { zip, fromPairs } from 'lodash'

import LikertPoint from './Point.vue'
import IsScale from './IsScale'
import Localized from '@/components/Localized'

export default Vue.extend({
  components: { LikertPoint, Localized },
  computed: {
    isEmpty(): boolean {
      return this.value[this.variable] === undefined
    },
    points(): Array<{ label: any; value: any }> {
      const labels = this.scale.points.map(e => e.label || (e.value && e.value.toString()))
      const values = this.scale.points.map(e => e.value)
      if (this.reversed) {
        values.reverse()
        return labels.map((e, i) => ({ label: e, value: values[i] }))
      } else {
        return labels.map((e, i) => ({ label: e, value: values[i] }))
      }
    },
    computedLocale(): string {
      return this.locale || this.$i18n.locale
    },
  },
  props: {
    anchors: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [String, Object],
    },
    required: {
      type: Boolean,
      default: false,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
    scale: {
      required: true,
      type: Object as () => IsScale,
    },
    value: {
      required: true,
      type: Object,
    },
    variable: {
      required: true,
      type: String,
    },
    locale: {
      type: String,
    },
  },
})
